import { render, staticRenderFns } from "./quitclaim-files.vue?vue&type=template&id=58593ccd&scoped=true&"
import script from "./quitclaim-files.vue?vue&type=script&lang=js&"
export * from "./quitclaim-files.vue?vue&type=script&lang=js&"
import style0 from "./quitclaim-files.vue?vue&type=style&index=0&id=58593ccd&scoped=true&lang=css&"
import style1 from "./quitclaim-files.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58593ccd",
  null
  
)

export default component.exports